import {useIntl} from 'react-intl';
import * as React from 'react';
import {useEffect, useRef, useState} from 'react';
import {ReactiveTable} from "react-ive-tables";
import {
    BankTransactionPaymentWithType,
    InvoiceWithPayment,
    ProcessedBankTransactionResponse
} from "../../../lib/types/types";
import {formatNumber} from "../../../lib/common";
import moment from "moment";

interface Props {
    selectedBankTransaction: ProcessedBankTransactionResponse
}

const TransactionPayments: React.FC<Props> = props => {
    const {formatMessage: f} = useIntl();
    const didMountRef = useRef(false);

    const [tableData, setTableData] = useState<BankTransactionPaymentWithType[]>();

    useEffect(() => {
        if (!didMountRef.current) {
            didMountRef.current = true;
        }
    }, []);

    useEffect(() => {
        const advancePayments: BankTransactionPaymentWithType[] = props.selectedBankTransaction.advancePayments.map(ip => {
            return {...ip, type: "advancePayment"};
        });

        const invoicePayments: BankTransactionPaymentWithType[] = props.selectedBankTransaction.invoicePayments.map(ip => {
            return {...ip, type: "invoicePayment"}
        });
        
        const res = [...advancePayments, ...invoicePayments];
        
        //Sort by date
        res.sort((a,b) => new Date(b.dateCreated).getTime() - new Date(a.dateCreated).getTime());
        setTableData(res);
    }, [props.selectedBankTransaction]);

    const getColumnTemplate = () => {
        return {
            amount: (rowData: BankTransactionPaymentWithType) => formatNumber(rowData.amount),
            type: (rowData: BankTransactionPaymentWithType) => f({id: rowData.type}),
            dateCreated: (rowData: BankTransactionPaymentWithType) => moment(rowData.dateCreated).format("DD-MM-YYYY HH:mm"),
            date: (rowData: BankTransactionPaymentWithType) => moment(rowData.date).format("DD-MM-YYYY"),
        };
    }

    const rowClass = (data: BankTransactionPaymentWithType) => {
        return {
            'overdue-invoice': data.hasCreditNotice
        }
    }

    return <>
        <ReactiveTable
            columnOrder={['amount', 'date', 'dateCreated', 'invoiceNumber', 'type']}
            data={tableData}
            showFilters={false}
            showPaginator={false}
            columnTemplate={getColumnTemplate()}
            specialLabels={{
                dateCreated: "dateProcessed"
            }}
            dtProps={{
                rowClassName: rowClass,
            }}
        />

    </>
};

export default TransactionPayments
